import { IApplicationState } from '../../types/redux';

export function getSelectedHouseId(state: IApplicationState) {
  return state.offers.selectedHouseId;
}
